import { render, staticRenderFns } from "./ArtworkIntakeUpsell.vue?vue&type=template&id=31353322&scoped=true&"
import script from "./ArtworkIntakeUpsell.vue?vue&type=script&lang=js&"
export * from "./ArtworkIntakeUpsell.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkIntakeUpsell.vue?vue&type=style&index=0&id=31353322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31353322",
  null
  
)

export default component.exports